var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.BModal,
    {
      attrs: {
        "modal-class": "vue-need-bootstrap",
        "header-class": "px-3",
        "title-class": "font-weight-bold",
        "body-class": "pb-1",
        "ok-only": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        scrollable: "",
        centered: "",
        title: _setup.getTitle,
        size: "lg",
        "hide-footer": "",
      },
      model: {
        value: _vm.saveTemplateModal.isOpen,
        callback: function ($$v) {
          _vm.$set(_vm.saveTemplateModal, "isOpen", $$v)
        },
        expression: "saveTemplateModal.isOpen",
      },
    },
    [
      _c("div", { staticClass: "content px-1" }, [
        _c("p", { staticClass: "text" }, [
          _vm._v("\n            Your template\n            "),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_setup.productTitle)),
          ]),
          _vm._v("\n            has been saved.\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center mt-2" }, [
          _c("p", { staticClass: "text mb-0" }, [
            _vm._v("\n                Template ID:\n                "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: "Copied to clipboard!",
                      trigger: "click",
                    },
                    expression:
                      "{ content: 'Copied to clipboard!', trigger: 'click' }",
                  },
                ],
                staticClass: "text-primary underline",
                on: { click: _setup.copyToClipboard },
              },
              [_vm._v(_vm._s(_vm.saveTemplateModal.productId))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-4" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: "Copied to clipboard!",
                      trigger: "click",
                    },
                    expression:
                      "{ content: 'Copied to clipboard!', trigger: 'click' }",
                  },
                ],
                staticClass: "btn copy-btn gray-backgorund",
                on: { click: _setup.copyToClipboard },
              },
              [
                _c("font-awesome-icon", {
                  staticStyle: { color: "#333333" },
                  attrs: { icon: ["fas", "copy"] },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text mt-3" }, [
          _vm._v(
            "You can return to Templates to continue editing or connect it to a product."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _setup.isEmbedded
            ? _c(
                "b-button",
                {
                  staticClass: "bottom-margin",
                  attrs: { variant: "primary" },
                  on: { click: _setup.onCloseClick },
                },
                [_vm._v("Close")]
              )
            : [
                _c(
                  "b-button",
                  {
                    attrs: { type: "reset", variant: "outline-primary" },
                    on: { click: _setup.onNavigateToHomeClick },
                  },
                  [_vm._v("Back to Templates")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "bottom-margin",
                    attrs: { variant: "primary" },
                    on: { click: _setup.onNavigateToTemplatesClick },
                  },
                  [_vm._v("Connect to Product")]
                ),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }